import { Component } from '@angular/core';

@Component({
  selector: 'app-footer-adminui',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterAdminuiComponent {}
